export default "__VITE_ASSET__Bupoa9m2__"